import { useGetAverages } from 'infrastructure/hooks/rpm';
import BaseSelect from 'components/molecules/select/base';
import { useTranslation } from 'react-i18next';
import { useState, type FC } from 'react';
import useUser from 'utils/useUser';
import { endOfDay, lastDayOfMonth } from 'date-fns';
import { Flex, Typography, Skeleton } from 'antd';

import s from './styles.module.scss';
import { getOptions, type IOption } from './utils';
import AverageCell from './cell';

const { Text } = Typography;

const SKELETON_CELLS_COUNT = 10;
interface AveragesProps {
  patientGuid: string;
  endTime: number;
}

const Averages: FC<AveragesProps> = ({ patientGuid, endTime }) => {
  const { averages, isLoading } = useGetAverages({
    patientGuid,
    endTime: endOfDay(lastDayOfMonth(endTime)).getTime(),
  });
  const { isMobileDevice } = useUser();
  const { t } = useTranslation();
  const options = getOptions(t);

  const [currentPeriod, setCurrentPeriod] = useState<IOption>(options[0]);

  return (
    <>
      <Flex
        className={s.select}
        gap={8}
        align="center"
        onClick={(e) => e.stopPropagation()}
      >
        <Text>
          {isMobileDevice
            ? t('overviewDashboard.patientAverage')
            : t('labels.average')}
        </Text>
        <BaseSelect
          options={options}
          onSelect={(val) => {
            setCurrentPeriod(val);
          }}
          value={currentPeriod}
          allowClear={false}
          width={isMobileDevice ? '50%' : undefined}
        />
      </Flex>
      <div className={s.wrapper}>
        {isLoading
          ? Array.from({ length: SKELETON_CELLS_COUNT }).map((_, idx) => (
              <Skeleton.Node key={idx} active className={s['skeleton-cell']} />
            ))
          : averages?.[currentPeriod.value]?.map((average, idx) => (
              <AverageCell average={average} key={idx} />
            )) || []}
      </div>
    </>
  );
};
export default Averages;
